export const EMAIL_TAG_TYPE = 'Email' as const;
